import router from "@/routes";

const publicPaths = [
    // TODO: Either add paths here that work without auth, or remove the public paths logic.
];

export function currentRouteIsPublic() {
    return routeIsPublic(router.currentRoute);
}

export function routeIsPublic(route) {
    return publicPaths.some(publicPath => {
        const routeSegments = route.path.split("/").filter(Boolean);
        const publicPathSegments = publicPath.split("/").filter(Boolean);

        if (routeSegments.length === 0 || publicPathSegments.length === 0) {
            return false;
        }

        return publicPathSegments.every((segment, index) =>
            routeSegments[index] === segment
        );
    });
}

export function goTo(path) {
    if (router.currentRoute.path !== path) {
        router.push(path);
    }
}

export default {
    goTo,
    routeIsPublic,
    currentRouteIsPublic
};
